export const REGEX_SCRIPT_TAG = /<script[\s\S]*?>[\s\S]*?<\/script>/gi
export const REGEX_SPECIAL_CHAR_WITH_EMOJIS = /[#$%^*\-[\]{};:\\|]+/g
export const REGEX_SPECIAL_CHARACTERS = /[#$%^*[\]{};:\\|]+/g
export const REGEX_HTML_TAG = /<[^>]*>/gi
export const REGEX_INDONESIA_VEHICLE_PLATE = /^([A-Z]{1,3})(\s|-)*([1-9][0-9]{0,3})(\s|-)*([A-Z]{0,3}|[1-9][0-9]{1,2})$/i
